import React, { useState } from 'react';

interface AdditionalViewProps {
  customerDetails: { comments: string | undefined };
  nextView: () => void;
  updateCustomerDetails: (details: { comments: string | undefined }) => void;
}

const AdditionalView = ({
  customerDetails,
  nextView,
  updateCustomerDetails,
}: AdditionalViewProps): JSX.Element => {
  const [message, setMessage] = useState<string | undefined>();

  const updateComments = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setMessage(event.target.value);
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    updateCustomerDetails({
      comments: message,
    });
    nextView();
  };

  return (
    <div className="db-modal__content">
      <form onSubmit={handleSubmit}>
        <section className="db-section ac-animation--fade-in-from-right">
          <p className="db-question">Other information</p>
          <p className="ch-mb--4 ch-fs--3 ch-color--grey-6">
            We&apos;ll pass any messages on to one of our Product Consultants.
          </p>
          <div className="ch-form__group">
            <label className="ch-fs--3 ch-label" htmlFor="enquiry[comments]">
              Your message{' '}
              <span className="ch-color--grey-6 ch-fw--400">(optional)</span>
            </label>
            <textarea
              className="ch-form__control"
              defaultValue={customerDetails.comments}
              name="enquiry[comments]"
              onChange={updateComments}
            />
          </div>
        </section>
        <section className="db-section db-section--cta">
          <button className="ch-btn ch-btn--block ch-btn--cta" type="submit">
            Next: Billing address
          </button>
        </section>
      </form>
    </div>
  );
};

export default AdditionalView;
